<template>
  <div>
    <el-row type="flex" justify="space-between" class="title-bar">
      <div class="vertical-center-box">
        <span class="title-h3 mr-r4">사전 예측 이벤트</span>
        <el-button v-if="predictTaskFlag" class="customised-icon pause mr-r4" size="small" @click="clickTaskControlBtn"></el-button>
        <el-button v-else class="customised-icon play-icon mr-r4" size="small" @click="clickTaskControlBtn"></el-button>
        <el-button :disabled="!isAbleConfirmBtn" size="small" @click="clickConfirmBtn">확인</el-button>
      </div>
      <div class="vertical-center-box">
        <el-button type="secondary" :disabled="!isAbleConfirmBtn" class="mr-r4" size="small" @click="openRscSmartAnalyzerPopup">Smart Analyzer</el-button>
        <w-recommend-handling-trouble-button class="mr-r4" :disabled-flag="isAbleConfirmBtn" :event-hist-seq-numbers="eventHistSeqNumbers" :is-predict-event="true"></w-recommend-handling-trouble-button>
        <el-button size="small" @click="exportExcel" class="mr-r4"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper
        v-loading="isLoading" style="width:100%;" ref="predictTable" border header-align="center"
        :data="predictTableData" :columns="predictColumns" pagination :total="total" :show-custom-header="true"
        :show-search-tool="showSearchTool" @condition-change="loadData" @selection-change="changeHandleSelection" remote>
        <template slot-scope="scope" slot="eventlevel-slot">
          <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId" />
        </template>
        <template slot-scope="scope" slot="confirm-slot"> </template>
        <template slot-scope="scope" slot="event-message-slot">
          <span class="link c-pointer" @click="clickEventMessage(scope.row)">{{ scope.row.eventMessage }}</span>
        </template>
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-resource-smart-analyzer-popup />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { isNil, isEmpty, forEach, isEqual } from 'lodash';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WRecommendHandlingTroubleButton from '@/views/event/components/RecommendHandlingTroubleButton';
import WResourceSmartAnalyzerPopup from '@/components/popup/ResourceSmartAnalyzerPopup';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';
import { routePathByObjEventHist, routePathByObjId } from '@/utils/router';
import { getDateToString } from '@/utils/date';
import FileApi from '@/api/common/file';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

export default {
  name: 'WEventPredict',
  components: {
    WEventlevelCell,
    WRecommendHandlingTroubleButton,
    WResourceSmartAnalyzerPopup,
  },
  props: {
    active: Boolean,
    default: false,
  },
  data() {
    return {
      isLoading: false,
      showSearchTool: false,
      total: 0,
      predictTaskFlag: true,
      selectedRows: [],
      histParams: {},
      eventHistSeqNumbers: [],
      predictTaskName: 'predictTask',
      predictTableData: [],
      predictColumns: [
        {
          type: 'selection',
          width: 41,
        },
        {
          prop: 'eventlevelName',
          label: '등급',
          width: 80,
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          searchable: true,
          searchType: 'eventlevel',
          remoteProp: 'peh.eventlevel_id',
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 110,
          headerAlign: 'center',
          searchable: true,
          remoteProp: 'mt.managetype_name',
        },
        {
          prop: 'objName',
          label: '대상',
          width: 110,
          headerAlign: 'center',
          scopedSlot: 'obj-name-slot',
          formatter: this.getTargetInfo,
          searchable: true,
          remoteProp: 'o.obj_name',
        },
        {
          prop: 'rsctypeName',
          label: '자원구분',
          width: 120,
          headerAlign: 'center',
          searchable: true,
          remoteProp: 'rt.rsctype_name',
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          searchable: true,
          headerAlign: 'center',
          scopedSlot: 'event-message-slot',
          remoteProp: 'peh.event_message',
        },
        {
          prop: 'checkDatetime',
          label: '예상 발생 시각',
          width: 180,
          headerAlign: 'center',
          formatter: this.getDateFormatter,
          searchable: false,
        },
        {
          prop: 'confirmFlag',
          label: '확인',
          width: 70,
          align: 'center',
          headerAlign: 'center',
          filters: [
            {
              text: '확인',
              value: 'Y',
            },
            {
              text: '미확인',
              value: 'N',
            },
          ],
          remoteProp: 'peh.confirm_flag',
          formatter: this.getComfirmFlagFormatter,
        },
      ],
    };
  },
  computed: {
    isAbleConfirmBtn() {
      return this.selectedRows.length > 0;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    active: {
      handler() {
        if (this.active === false) {
          this.removePredictEventTask();
        } else {
          this.$store.dispatch('setSelectedEvents', []);
          this.startPredictEventTask(true);
        }
      },
      immediate: true,
    },
    selectedNode: {
      handler() {
        if (this.active) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.removePredictEventTask();
  },
  methods: {
    /**
     * 사전예측 이벤트 탭인 경우 태스크를 생성한다.
     * @author yelim
     */
    startPredictEventTask(startFlag) {
      if (!this.$taskManager.existTask(this.predictTaskName)) {
        this.loadData();
      }
      this.$taskManager.createTask(this.predictTaskName, 30, this.loadData);
      if (startFlag) {
        this.$taskManager.startTask(this.predictTaskName);
      }
    },
    /**
     * 사전예측 이벤트 탭을 벗어나는 경우 태스크를 제거한다.
     * @author yelim
     */
    removePredictEventTask() {
      if (this.$taskManager.existTask(this.predictTaskName)) {
        this.$taskManager.removeTask(this.predictTaskName);
      }
    },
    /**
     * 선택된 사전 예측 이벤트 항목을 관리한다.
     * @author yelim
     */
    changeHandleSelection(rows) {
      this.selectedRows = [];
      this.eventHistSeqNumbers = [];
      this.selectedRows = rows;
      this.selectedRows.forEach((item) => {
        this.eventHistSeqNumbers.push(item.seqNumber);
      });
    },
    /**
     * 사전 예측 이벤트 목록을 조회한다.
     * @author yelim
     */
    loadData() {
      const histParams = this.getListParameters();
      this.$nextTick(() => {
        const tableParams = this.$refs.predictTable.getParameter();
        const params = {};
        Object.assign(params, tableParams, histParams);
        EventPredictSettingsAPI.getPredictEventHist(params).then((response) => {
          if (response.data.success) {
            this.predictTableData = response.data.data;
          }
        });
      });
    },
    /**
     * 장애 메시지 클릭 시 해당 이벤트의 관리 대상의 성능운영 > 요약 화면으로 이동한다.
     */
    clickEventMessage(row) {
      if (!isNil(row.objId)) {
        routePathByObjEventHist(this, row.objId, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, row.checkDatetime);
        // 태스크가 남아있는 현상으로 추가
        this.removePredictEventTask();
      }
    },
    /**
     * date to string formatter
     * @author yelim
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 확인 컬럼 converter
     * @author yelim
     */
    getComfirmFlagFormatter(row, column, value) {
      if (!isNil(value)) {
        return value === 'Y' ? '확인' : '미확인';
      }
      return EMPTY_TEXT;
    },
    /**
     * 태스크 실행 / 중지를 제어한다.
     * @author yelim
     */
    clickTaskControlBtn() {
      if (this.predictTaskFlag) {
        this.predictTaskFlag = false;
        this.$taskManager.stopTask(this.predictTaskName);
      } else {
        this.predictTaskFlag = true;
        this.$taskManager.startTask(this.predictTaskName);
      }
    },
    /**
     * 선택한 사전예측 이벤트 항목을 확인처리한다.
     * @author yelim
     */
    clickConfirmBtn() {
      const seqNumbers = [];
      this.selectedRows.forEach((item) => {
        seqNumbers.push({ seqNumber: item.seqNumber });
      });
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.CHECK)).then(() => {
        EventPredictSettingsAPI.setConfirmPredictEvent(seqNumbers).then((response) => {
          if (response.data.success) {
            this.loadData();
            this.$message(msgUtil.getResultMsgData(msgUtil.action.CHECK, '사전 예측 이벤트', response.data.success));
          }
        });
      });
    },
    /**
     * 엑셀 출력/ 이벤트 목록 조회를 위한 파라미터를 리턴한다.
     * @author yelim
     */
    getListParameters() {
      const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
      const type = this.selectedNode.type;
      // debugger;
      const histParams = {
        treeType,
        type,
      };
      if (isEqual(treeType, 'logical')) {
        if (type !== 'root') {
          if (isEqual(type, 'group')) {
            if (this.selectedNode.subType === 'virtual') {
              histParams.objId = this.selectedNode.objId;
              histParams.objtypeId = this.selectedNode.obj.objtypeId;
              histParams.subType = this.selectedNode.subType;
            } else {
              histParams.managegroupIds = this.selectedNode.childManagegroupIds;
            }
          } else if (isEqual(type, 'obj')) {
            histParams.objId = this.selectedNode.obj.objId;
          }
        }
      } else if (isEqual(treeType, 'physical')) {
        if (isEqual(type, 'group')) {
          histParams.managetypeId = this.selectedNode.managetypeId;
          histParams.objtypeId = this.selectedNode.objtypeId;
          // nms일 경우
          histParams.objCompanyId = this.selectedNode.objCompanyId;
          // vms일 경우
          histParams.hypervisorType = this.selectedNode.hypervisorType;
          histParams.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
          histParams.objId = this.selectedNode.objId;
          histParams.subType = this.selectedNode.subType;
        } else if (isEqual(type, 'obj')) {
          histParams.objId = this.selectedNode.obj.objId;
        }
      }
      return histParams;
    },
    /**
     * 조회한 사전 예측 이벤트 목록을 엑셀 출력한다.
     * @author yelim
     */
    exportExcel() {
      const params = {};
      const histParams = this.getListParameters();
      const tableParams = this.$refs.predictTable.getParameter();
      Object.assign(params, tableParams, histParams);
      EventPredictSettingsAPI.getPredictEventInfoExcelName(params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      });
    },
    /**
     * 자원 Smart Analyzer 팝업을 연다.
     * @author yelim
     * @return {[type]}
     */
    openRscSmartAnalyzerPopup() {
      const objRscKeyList = [];
      forEach(this.selectedRows, (item) => {
        objRscKeyList.push({
          objId: item.objId,
          managetypeId: item.managetypeId,
          rsctypeId: item.rsctypeId,
          rscId: item.rscId,
          rscKey: item.rscKey,
        });
      });
      this.$store.dispatch('openResourceSmartAnalyzerPopup', objRscKeyList);
    },
    /**
     * 장비이름 formatter, 기본적으로는 '장비 명 + (ip)' 형식이며 NI의 경우 parent의 objName과 ip 형식을 사용한다.
     * @author Song
     * @return {[type]}
     */
    getTargetInfo(row, column, value) {
      if (row.objDefineId === 'NETINTERFACE') {
        return `${getValueAfterCheckEmpty(value)} (${getValueAfterCheckEmpty(row.parentObjName)}/${getValueAfterCheckEmpty(row.ipaddress)})`;
      }
      if (row.objDefineId !== 'SERVICE' && row.objDefineId !== 'E2E_SERVICE' && row.objDefineId !== 'FMS_SENSOR') {
        return `${getValueAfterCheckEmpty(value)} (${getValueAfterCheckEmpty(row.ipaddress)})`;
      }
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/event/event-predict/index.vue